import { useScanCodeConfigV1ControllerGetByProject } from 'generated/apiComponents';

import { useSession } from 'technical/auth/client';

export const useGetScanCodeConfigData = (searchData: boolean) => {
  const { data: session } = useSession();

  const { data, error, isLoading } = useScanCodeConfigV1ControllerGetByProject(
    {
      queryParams: {
        projectId: session?.user.projectId ?? '',
      },
    },
    {
      enabled: !!session?.user.projectId && searchData,
    },
  );

  return {
    data,
    loading: isLoading,
    error,
  };
};
